import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import './i18n'

// Capacitor native platform setup
import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'
import { SplashScreen } from '@capacitor/splash-screen'

async function initCapacitor() {
    try {
        if (Capacitor.isNativePlatform()) {
            // Add platform class to body for CSS targeting
            document.body.classList.add(`capacitor-${Capacitor.getPlatform()}`);

            if (Capacitor.getPlatform() === 'ios') {
                // Configure status bar for iOS to overlay webview so background extends
                await StatusBar.setOverlaysWebView({ overlay: true });
                await StatusBar.setStyle({ style: Style.Light });
            }

            // Hide splash screen after app is mounted
            await SplashScreen.hide();
        }
    } catch (err) {
        console.error('[Capacitor] Init error:', err);
    }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>,
)

// Initialize Capacitor after render
initCapacitor();
